import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=2fb3d71a&"
import script from "CJ/components/Feedback.component.js?vue&type=script&lang=js&"
export * from "CJ/components/Feedback.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports